import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgFavouriteFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.262 3A5.691 5.691 0 0 0 12.2 4.714l-.2.203-.198-.203a5.675 5.675 0 0 0-8.127 0c-2.232 2.274-2.232 5.954 0 8.229l7.612 7.757a1 1 0 0 0 1.428 0l7.612-7.757A5.873 5.873 0 0 0 22 8.828a5.874 5.874 0 0 0-1.674-4.114A5.691 5.691 0 0 0 16.262 3Z", fill: color }));
};
export default factorySvgIcon(SvgFavouriteFilled);
//# sourceMappingURL=SvgFavouriteFilled.js.map